/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Filters
import './filters/filters.js'

// Can
import './directives/can.js'

// Api
import api from './api'
Vue.prototype.$api = api

// VeeValidate
import VeeValidate from 'vee-validate'
import validateDictionary from './locale/validateDictionary'

Vue.use(VeeValidate, {
  locale: 'ru',
  events: 'blur',
  dictionary: validateDictionary
})


// VMask for inputs
import VueMask from 'v-mask'
Vue.use(VueMask)

// Infinite Scroll
import InfiniteLoading from 'vue-infinite-loading'
Vue.use(InfiniteLoading, {
  slots: {
    noMore: '',
    noResults: ''
  }
})

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// Миксин для изменения заголовка страницы (title)
import titleMixin from './mixins/titleMixin'
Vue.mixin(titleMixin)

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

import Auth from './api/http/models/auth/Auth'

function updateCookie () {
  Auth.csrfCookie()
}

(async () => {
  // Получения куков
  await updateCookie()

  // Получение текущего пользователя
  await store.dispatch('fetchAuthUser')

  // Инициализация vue приложения
  await new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

  // Автоматическое обновление куков каждые 30 мин
  setInterval(updateCookie, 30 * 60000)
})()
